// Aquí están los thunks relacionados con el registro de usuarios
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";
import { registerPending, registerSuccess, registerFailure, registerReset } from "./registerSlice";

/**
 * 📝 REGISTER — Envía datos de registro al backend
 */

export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (
    {
      nombre,
      apellido,
      numeroTributario,
      correo,
      telefono,
      fechaNacimiento,
      genero,
      imagenDePerfil,
      enabled,
      perEmpresa,
      perEmbajador,
      perValidador,
      facebook,
      instagram,
      tiktok,
      pais,
      ciudad,
      password,
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(registerPending());
      const { data } = await api.post("/auth/sign-up", {
        nombre,
        apellido,
        numeroTributario,
        correo,
        telefono,
        fechaNacimiento,
        genero,
        imagenDePerfil,
        enabled,
        perEmpresa,
        perEmbajador,
        perValidador,
        facebook,
        instagram,
        tiktok,
        pais,
        ciudad,
        password,
      });
      dispatch(registerSuccess());
      console.log("Registro exitoso:", data);
      return data;
    } catch (err) {
      console.error("Error de registro:", err);
      dispatch(registerFailure(err.response?.data || err.response?.data?.message || "Error de registro"));
      return rejectWithValue(err.response?.data || err.response?.data?.message || "Error de registro");
    }
  }
);
